import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { log } from 'util';

@Component({
  selector: 'app-student-status',
  templateUrl: './student-status.component.html',
  styleUrls: ['./student-status.component.scss']
})
export class StudentStatusComponent implements OnInit {
  studentStatus: FormGroup;
  ListOfMarks: any;
  filteredListOfCourse: any; 
  ListOfRgNo: any;
  filteredListOfRgNo: any;
  SessionNo: any;
  filteredstudentStatusList
  studentStatusList
  sessionList: any;
  SessionFilterList: any;
  Session: any;
  tableList: any;
  filteredtableList: any;
  examStatusList = []
  filteredExamStatusList = []
  CourseList
  filteredCourseList
  showForm = false;
  submitpayload: any;
  dialogRef: MatDialogRef<any>;
  examList
  filteredListExam
  tableShow = false;
  userPermission: any;
  utp: any;
  stuStCreate=true;
  stuStUpdate=true;
  isCollege: boolean = false;
  submitButton = true;
  updateButton = false;
  status: string;
  courseCode: any;
  TclcData: any;
  constructor(public umsService: UmsService, private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder) { }

  ngOnInit(): void {
    // Student Status
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Student Status' && element.PCreate == false) {
          this.stuStCreate = false;
        }
        if (element.PageName == 'Student Status' && element.PUpdate == false) {
          this.stuStUpdate = false;
        }
      });
    }
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.umsService.getSecretData().subscribe((res) => {
        this.SessionNo = res.projectPharam['SnNo']
        this.fetchList(this.SessionNo);
        this.ShowTable(this.SessionNo)
      }
      );

    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.fetchList(this.SessionNo);
      this.ShowTable(this.SessionNo)
    }
    this.studentStatus = this.fb.group({
      list: new FormControl(''),
      list2: new FormControl(''),
      list3: new FormControl(''),
      Colg: new FormControl(''),
      Debar: new FormControl(''),
      Chng: new FormControl(''),
      RgId: new FormControl('',Validators.required),
      RgName: new FormControl(''),
      Name: new FormControl(''),
      EcId: new FormControl('', Validators.required),
      CoCode: new FormControl(''),
      SetRem: new FormControl('',Validators.required),
      EmId: new FormControl(''),
      StrId: new FormControl(''),
      StatusRg: new FormControl(''),
      StatusRe: new FormControl(''),
      Type: new FormControl(''), //not konwn value
      ShIdRe: new FormControl(''),  //not konwn value
      BarToYr: new FormControl(''),
      BarToSn: new FormControl(''),
    })

    this.fetchSession('');
    this.fetchStudentStatus();
    this.fetchExamStatus();
    this.fetchCourseCode2();
    this.getCollegeData(this.userPermission);
    this.studentStatus.controls['StatusRg'].setValue('L');
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
    }
    );
  }

  fetchList(SessionNo) {
    let payload = {}
    payload["SnNo"] = SessionNo;
    payload["InCode"] = 52;
    payload["OpId"] = parseInt(sessionStorage.getItem('userId'))
    this.umsService.fetchRegiList(payload).subscribe((res) => {
      if (res.status) {
        this.ListOfMarks = res.data;
        this.filteredListOfCourse = this.ListOfMarks.slice();
      }
      else {

      }

    });

  }


  fetchListForRgNo(item) {
    this.courseCode = item.CoCode;
    let payload = {}
    payload['CoCode'] = item.CoCode,
    this.ListOfRgNo = [];
    this.filteredListOfRgNo = [];
    this.studentStatus.controls['RgName'].setValue('');
    this.studentStatus.controls['RgId'].setValue('');
    this.umsService.fetchRegNoList(payload).subscribe((res) => {
      if (res.status) {
        let admLeft = []
        admLeft = this.TclcData.filter(record => record.StuCourse == item.CoCode && record.CertType === "ADMC" && record.CertStatus === "APPAP");
        let matchingRgNoList = res.data.filter(student =>
        admLeft.some(tclcRecord => tclcRecord.RgNo === student.RgNo)
      );
        this.ListOfRgNo = matchingRgNoList;
        this.filteredListOfRgNo = this.ListOfRgNo.slice();
      }
      else {
 
      }
 
    });
 
  }
  getTableData() {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Student Status' && element.PCreate == false) {
          this.stuStCreate = false;
        }
        if (element.PageName == 'Student Status' && element.PUpdate == false) {
          this.stuStUpdate = false;
        }
      });
    }
    this.studentStatus.controls['StatusRg'].setValue('L');
    this.showForm = false;
    this.tableShow = false;
    let formvalue = this.studentStatus.value
    this.spinner.show()
    if (this.studentStatus.value.EcId != '') {
      this.showForm = true;
      const payload = {};
      payload['EcId'] = formvalue['EcId'];
      payload['CgCode'] = '';
      payload['Valid'] = '';
      payload['Chng'] = ''
      this.umsService.fetchTableDataList(payload).subscribe((res) => {
        if (res.status) {
          this.tableShow = true
          this.spinner.hide()
          this.tableList = res.data;
          this.filteredtableList = this.tableList.slice();
        } else {
          //this.apimicroservice.openSnackbar(res.message);
          this.spinner.hide()
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.tableList = []
      });
    }
    else {
      this.spinner.hide();
      this.studentStatus.get('EcId').markAsTouched();
    }
  }

  getDetails(item) {
    this.studentStatus.controls['RgName'].setValue(item.RgName);
  }
  fetchStudentStatus() {
    const payload = {};
    payload['CdType'] = 'StuS';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.studentStatusList = res.data;
        this.filteredstudentStatusList = this.studentStatusList.slice();
        // this.studentStatus.controls['StatusRg'].setValue(['LEFT']);
      } else {
        
      }
    });
  }


  fetchSession(id) {
    this.Session = 0
    this.spinner.show();
    const payload = {};
    payload['SnDefault'] = id;
    payload['SnNo'] = id;
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })

  }


  fetchExamStatus() {
    const payload = {};
    payload['CdType'] = 'ExSt';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.examStatusList = res.data;
        this.filteredExamStatusList = this.examStatusList.slice();
      } else {
        //this.apimicroservice.openSnackbar(res.message);
      }
    });
  }

  fetchCourseCode2() {
    const payload = {};
    this.umsService.getCourse(payload).subscribe((res) => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredCourseList = this.CourseList.slice();
      } else {
      }
    });
  }

  getExamData(e) {
    const payload = {};
    payload['EmCoCode'] = e.CoCode;
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();

      }
      else {
        this.examList = [];
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  submit(){
    if(this.studentStatus.invalid){
      this.studentStatus.controls['SetRem'].markAsTouched();
      this.studentStatus.controls['RgId'].markAsTouched();
    }
    else{
      this.save()
    }
    
  }

  save() {
    this.spinner.show();
    if(this.studentStatus.value.StatusRg == 'L')
    {
      this.status = 'Left'
    }
    else if(this.studentStatus.value.StatusRg == 'B')
      {
      this.status = 'Barred'
      }
    this.submitpayload = this.studentStatus.value;
    this.submitpayload['Type'] = 'S';
    this.submitpayload['TypeDesc'] = 'Student Status';
    this.submitpayload['StatusRg'] =this.studentStatus.value.StatusRg;
    this.submitpayload['Details'] = 'Set to ' + this.status;
    this.submitpayload['CoCode'] = this.courseCode;
    this.umsService.addStudentStatus(this.submitpayload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          // this.dialogRef2.close();
          this.getTableData()
          // this.studentStatus.reset();
          this.studentStatus.controls['SetRem'].setValue('');
          this.studentStatus.controls['RgId'].setValue('');
          this.studentStatus.controls['RgName'].setValue('');
          this.studentStatus.controls['SetRem'].markAsUntouched();
          this.studentStatus.controls['RgId'].markAsUntouched();
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  update() {
    this.spinner.show();
    this.submitpayload = this.studentStatus.value;
    this.umsService.updateStudentStatus(this.submitpayload).subscribe(res => {
    
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe((result) => {
          this.getTableData()
          this.studentStatus.reset();
        });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  reset() {this.studentStatus.reset()
    this.studentStatus.controls['EcId'].setValue('');
    this.studentStatus.get('EcId').markAsUntouched();
    
    this.showForm = false;
    this.tableShow = false;
  }

  editdata(data) {
    this.submitButton = false;
    this.updateButton = true;
    this.studentStatus = this.fb.group({
      Colg: new FormControl(''),
      Debar: new FormControl(''),
      Chng: new FormControl(''),
      RgId: new FormControl(data.RgId,Validators.required),
      RgName: new FormControl(data.RgName),
      EcId: new FormControl(data.EcId, Validators.required),
      CoCode: new FormControl(data.CoCode),
      SetRem: new FormControl(data.SetRem,Validators.required),
      EmId: new FormControl(data.EmId),
      StrId: new FormControl(data.StrId),
      StatusRg: new FormControl(data.StatusRg),
      StatusRe: new FormControl(data.StatusRe),
      Type: new FormControl(data.Type), //not konwn value
      ShIdRe: new FormControl(data.ShIdRe),  //not konwn value
      BarToYr: new FormControl(data.BarToYr),
      BarToSn: new FormControl(data.BarToSn),
    })
  }

  getCollegeData(userPermission: any) {
    this.spinner.show();
    let UserCollege = '';
    this.isCollege = false;
    if(userPermission[0].CgUi == 'C'){
      UserCollege = userPermission[0].CgId;
      this.isCollege = true;
    }
    const payload = { 'CgCode': UserCollege };
    this.umsService.getCollege(payload).subscribe(
      (res) => {
        this.spinner.hide();
        const CgName = res.data;
        if(userPermission[0].CgUi == 'C'){
          this.studentStatus.controls['Colg'].setValue(CgName[0].CgName);
          // this.isCollege = true;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        return [];
      }
    );
  }


  ShowTable(SnNo){
    const payload = {};
    payload['SessionId'] = SnNo;
    payload['CertType'] = 'All'
    this.umsService.GetTclcData(payload).subscribe((res) => {
     if(res.status){
      if(this.userPermission[0].CgUi == 'C'){
        this.TclcData = res.data.filter(record => record.StuCollege == this.userPermission[0].CgId && record.CertType == 'ADMC');
       }
      else{
        this.TclcData = res.data
      }
     }
    }, (ERROR: HttpErrorResponse) => {
     
    });
   
  }
}
